'use strict';

module.exports = {
    SIGN: 'Zarejestruj się',
    SIGN_JOIN: 'Zaloguj się lub dołącz za darmo!',
    EMAIL_EXISTS: 'Ten adres e-mail już istnieje.',
    INVALID_EMAIL: 'Podaj prawidłowy adres e-mail',
    INVALID_FIRST_NAME: 'Wprowadź imię',
    INVALID_LAST_NAME: 'Wprowadź nazwisko',
    INVALID_PASSWORD: 'Prose wprowadzić 6-20 znaków (wyłącznie A-Z, a-z, 0-9)',
    INVALID_REPASSWORD: 'Hasła nie są takie same',
    INVALID_VALID_CODE: 'Podaj poprawny kod',
    UNAVIALABLE_SERVICE: 'Usługa jest niedostępna, prosimy spróbować ponownie później',
    EMPTY_VALID_CODE: 'Wpisz znaki, które widzisz na zdjęciu',
    NOT_MEMBER: 'Nie jesteś członkiem?',
    ALREADY_MEMBER: 'Jesteś już członkiem AliExpress/Alibaba?',
    EMAIL: 'Adres e-mail',
    CONTACT_NAME: 'Osoba do kontaktu:',
    FIRST_NAME: 'Imię',
    LAST_NAME: 'Nazwisko',
    PASSWORD: 'Hasło',
    REPASSWORD: 'Wprowadź hasło ponownie:',
    EMPTY_CODE: 'Wprowadź wyświetlony kod:',
    REFRESH: 'Odśwież',
    CREATE_MY_ACCOUNT: 'Załóż konto',
    NAME: 'Imię',
    VERIFICATION: 'Kod weryfikacyjny',
    AGREE_MENT: 'Tworząc konto, użytkownik wyraża zgodę na',
    AE_MEMBER_SHIP: 'darmową umowę członkowską AliExpress.com',
    AND: 'i',
    PRIVACY_POLICY: 'Zasady prywatności',
    SLIDE_SUBMIT: 'PRZESUŃ W PRAWO, ABY ZWERYFIKOWAĆ',
    SLIDE_SUBMIT_TIPS: 'Powodzenie',
    LOADING: 'Ładowanie…',
    SLIDE_SUBMIT_ERROR_TIPS: 'PRZESUŃ W PRAWO, ABY ZWERYFIKOWAĆ',
    SHOP_NOW: 'Kupuj teraz',
    SIGN_IN: 'Zaloguj',
    REGISTER_SMS: 'rejestracja za pomocą SMS',
    REGISTER_EMAIL: 'Zarejestruj się za pomocą e-maila',
    PHONE_NUMBER: 'Numer telefonu',
    VALID_NUMBER: 'Wprowadź poprawny numer telefonu.',
    SEND_SMS_CODE: 'Wyślij kod SMS',
    SMS_POLICY: 'Wyślemy kod weryfikacyjny przez SMS na podany numer telefonu. Upewnij się, że kod kraju i numer telefonu są prawidłowe.',
    SEND_TO: 'Wysłaliśmy kod na numer',
    VERIFICATION_RECEIVED: 'Wprowadź otrzymany kod weryfikacyjny lub',
    EDIT_NUMBER: 'edytuj numer.',
    RESEND_CODE: 'Wyślij kod ponownie',
    LAST_STEP: 'Ostatni krok',
    SET_SIGN_IN_PASSWORD: 'Proszę ustawić hasło logowania, aby Twoje konto było bezpieczniejsze.',
    INVALID_PHONE_PASSWORD: '6-20 znaków (tylko litery i cyfry)',
    NOT_CORRECT_CODE: 'Kod jest niepoprawny, spróbuj ponownie.',
    SAVE_PASSWORD: 'Zapisz hasło',
    NO_RECEIVED_CODE: 'Jeśli kod nie dotarł, spróbuj',
    VIA_EMAIL: 'zarejestrować się przez e-mail'
};